// extracted by mini-css-extract-plugin
module.exports = {"black":"Icon-module__black___1jamr","blue":"Icon-module__blue___2viIF","grey":"Icon-module__grey___r1-ha","white":"Icon-module__white___3L99D"};